/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useState, useEffect, createContext, useContext } from 'react';

import { useGetTextMessage } from '../services/TextMessageService';
import LoaderContext from './LoaderContext';

import { Skeletons } from '@fitinsur/components/Skeletons';

export const TextMessageContext = createContext({
  textMessages: {},
  getTextMessages: () => null,
  getDescription: () => null,
});

export const TextMessageProvider = ({ children }) => {
  const { isLoading, updateIsLoadingStatus } = useContext(LoaderContext);

  const {
    request: useGetTextMessageRequest,
    loading: useGetTextMessageLoading,
  } = useGetTextMessage();

  const [textMessages, setTextMessages] = useState({});

  function getTextMessages({ domainIds, models, isoCode }) {
    useGetTextMessageRequest(null, { domainIds, models, isoCode, }).then(({ data }) => {
      const { value: models } = data;

      setTextMessages((prevTextMessages) => {
        const updatedTextMessages = JSON.parse(JSON.stringify(prevTextMessages));

        models?.forEach((model) => {
          const { modelName, modelItems } = model;
          if (!updatedTextMessages[modelName]) {
            updatedTextMessages[modelName] = {};
          }

          modelItems.forEach((modelItem) => {
            const { modelItemId, defaultDescription, translatedDescription } = modelItem;
            updatedTextMessages[modelName][modelItemId] = {
              defaultDescription,
              translatedDescription,
            };
          });
        });

        return updatedTextMessages;
      });
    }).catch(err => console.log("error", err));
  }

  function getDescription(
    modelName,
    modelItemId,
    {
      withSkeleton,
      skeletonWidth,
      skeletonHeight,
      skeletonColor,
      textFormat
    } = {},
  ) {
    const domain = textMessages && textMessages[modelName] && textMessages[modelName][modelItemId]

    if (textFormat === 'uppercase') {
      return domain?.translatedDescription?.toUpperCase()
        || domain?.defaultDescription?.toUpperCase()
        || (withSkeleton && <Skeletons.SkeletonText width={skeletonWidth} height={skeletonHeight} color={skeletonColor} />);
    }

    return domain?.translatedDescription
      || domain?.defaultDescription
      || (withSkeleton && <Skeletons.SkeletonText width={skeletonWidth} height={skeletonHeight} color={skeletonColor} />);
  };

  useEffect(() => {
    //updateIsLoadingStatus(useGetTextMessageLoading);
  }, [isLoading, useGetTextMessageLoading]);

  return (
    <TextMessageContext.Provider
      value={{
        getTextMessages,
        getDescription,
        textMessages
      }}
    >
      {children}
    </TextMessageContext.Provider>
  );
};
